// initial state
const state = () => ({
  showModal: false
})

// getters
const getters = {
  getStateSpeechRecognitionStore(state) {
    return state;
  },
}

// mutations
const mutations = {
  setStateSpeechRecognitionStore(state, payload) {
    state.showModal = payload;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
